import React from 'react';

import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import certificateImage from '../../Assets/img/certificate.webp';
import WithBackground from '../Common/WithBackground';

import './style.css';

const EmployerCertificate = ({ bg, overlay }) => {
  const { t } = useTranslation();

  const certificateContent = (
    <section className='EmployerCertificate'>
      <div className='EmployerCertificate__container'>
        <h2 className='EmployerCertificate__title'>
          {t('employer.certificates.title')}
        </h2>
        <div className='EmployerCertificate__content'>
          <div className='EmployerCertificate__image-wrapper'>
            <img
              src={certificateImage}
              alt='OPUS A.P.T Certificate'
              className='EmployerCertificate__image'
            />
          </div>
        </div>
      </div>
    </section>
  );

  return bg ? (
    <WithBackground bg={bg} overlay={overlay}>
      {certificateContent}
    </WithBackground>
  ) : (
    certificateContent
  );
};

EmployerCertificate.propTypes = {
  bg: PropTypes.string,
  overlay: PropTypes.oneOf(['dark', 'light', 'golden', 'none']),
};

EmployerCertificate.defaultProps = {
  bg: null,
  overlay: 'dark',
};

export default EmployerCertificate;
